import React from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

interface StatsProps {
    title: number;
    subtitle: string;
    delay: number;
    percent: boolean;
}

const Stats: React.FC<StatsProps> = ({ title, subtitle, delay, percent }) => {
    return (
        <div data-aos="fade-up" data-aos-duration="700" data-aos-delay={delay} className="flex flex-col px-4 py-8 shadow-lg transition-transform transform hover:scale-90 hover:shadow-2xl duration-300">
            <VisibilitySensor partialVisibility offset={{ bottom: 200 }} delayedCall>
                {({ isVisible }: { isVisible: boolean }) => (
                    <h5 className="font-normal text-blue-800">
                        {isVisible ? (
                            <>
                                <CountUp end={title} duration={5} />
                                {percent ? '%' : '+'}
                            </>
                        ) : (
                            '.'
                        )}
                    </h5>
                )}
            </VisibilitySensor>
            <p className="text-lg font-manrope font-medium text-red-700">{subtitle}</p>
        </div>
    );
};

const AboutStats: React.FC = () => {
    return (
        <div className="flex flex-col w-full px-[5%] justify-center py-24 gap-12">
            <h1 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100" className='text-blue-700'>
                Our legacy of <span className="text-primary">excellence</span>
            </h1>
            <div className="flex flex-col md:flex-row">
                <div className="grid items-center grid-cols-2 md:w-1/2 gap-y-0 md:gap-y-12 gap-x-12">
                    <Stats delay={99  } title={40} percent={false} subtitle="Projects Completed" />
                    <Stats delay={200} title={90} percent={true} subtitle="Satisfaction Rate" />
                    <Stats delay={0} title={8} percent={false} subtitle="Awards Received" />
                    <Stats delay={0} title={15} percent={false} subtitle="Qualified Team" />
                </div>
                <p
                    data-aos="fade-up"
                    data-aos-duration="700"
                    data-aos-delay="200"
                    className="flex flex-col gap-4 pt-4 text-lg md:w-1/2 font-manrope pl-4"
                >
                    <div>
                    From professional logo design to comprehensive social media management, CV Business Branding offers a full suite of services that ensure your brand stands out in today's competitive market.
                    </div>
                    <div>
                    CV Business Branding excels in delivering innovative digital solutions with a focus on creativity, precision, and results. Their team of experienced marketers and designers leverage the latest tools and techniques to craft tailored campaigns that resonate with your target audience, building a strong and lasting brand presence.
                    </div>
                </p>
            </div>
        </div>
    );
};

export default AboutStats;